<template>
  <div class="UserBindEmail">
    <div class="tipsContent bg_fff pa" @click.stop >
      <div class="tipsTitle f_18 color_40 font_w_b">公司邮箱验证 <span class="iconfont iconquxiao font_w_b fr cursor_p" @click.stop="hideUserBindEmailState()"></span></div>
      <div class="tipsText">
        <p class="f_14 color_60">为了确认您的身份，请使用该邮箱发送邮件</p>
        <p class="f_16 color_40">{{email}}</p>
      </div>

      <div class="form">
        <div class='formList flex'>
          <div class='title f_14 color_9c'>主题：</div>
          <div class='f_14 color_40 flex1'>邮箱验证</div>
        </div>
        <div class='formList flex-c'>
          <div class='title f_14 color_9c'>内容：</div>
          <div class='flex1 inputItem flex-c'>
            <div class='flex1 text f_14 color_60'>{{code}}</div>

            <div class='upload f_12 color_blue cursor_p' v-if="timeSize===0" @click="this.getCode"><Text class='iconfont iconrefresh'></Text> 刷新</div>
            <div class='time f_12 color_blue' v-else>{{time}} 后过期</div>

            <div v-if="timeSize===0" class="copyButton text_center color_blue f_14 cursor_p disabled" >复制</div>
            <div class="copyButton text_center color_blue f_14 cursor_p" v-else v-clipboard:copy="code" v-clipboard:success="copyText" v-clipboard:error="copyTextError" >复制</div>

          </div>
        </div>
        <div class='formList flex-c'>
          <div class='title f_14 color_9c'>发送至：</div>
          <div class='flex1 inputItem flex-c'>
            <div class='flex1 text f_14 color_60'>verify@jobmail.vip</div>
            <div class='copyButton text_center color_blue f_14 cursor_p' v-clipboard:copy="'verify@jobmail.vip'" v-clipboard:success="copyText" v-clipboard:error="copyTextError" >复制</div>
          </div>
        </div>

      </div>
      <div class="pr">
        <div class='errorTips color_blue f_14 pa' v-if="errorState"><span class='iconfont iconjinggao'></span> 系统尚未收到邮件，请稍后重试或重新发送 </div>
        <div class="submitButton text_center f_16 color_fff bg_current cursor_p" :class="[timeSize===0?'disabled':'']" @click="confirm">
          <span class="el-icon-loading" v-if="userBindEmailState"></span> 确认已发送验证邮件
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'UserBindEmail',
  props:{
    email:{
      default:'',
      type:String
    },
    errorState:{//是否提示错误
      default:false,
      type: Boolean
    }
  },
  data(){
    return {
      code:'', //邮箱验证码
      getCodeState:false, //获取验证码的状态
      timeSize:15*60-1,
      time:'14:59',
      timeName:'',
    }
  },
  computed:{
    ...mapState('block',['userBindEmailState'])
  },
  created(){
    this.getCode();
  },
  componentWillUnmount(){
    //清除定时器
    let { timeName } = this.state;
    clearInterval(timeName);
    this.setState({
      timeName
    })
  },
  methods:{
    ...mapMutations('block',['updateUserBindEmailState']),
    //取消
    hideUserBindEmailState(){
      this.$emit('hideUserBindEmailState')
    },
    //确定
    confirm(){
      if(this.timeSize===0){
        return false;
      }
      this.$emit('confirm',this.code)
    },
    //获取验证码
    getCode(){
      //发送验证码
      actions.hr_accounts.get_verification_codes({company_email: this.email}).then(res=>{
        if(res.code === 1000){
          //倒计时
          this.showTimeOut();
          //取消错误提示
          this.$emit('hideEmailBindError');
          this.code = res.data.code;
          this.errorState = false;
          this.timeSize = 15*60-1;
        }
      })
      
    },
    //倒计时
    showTimeOut(){
      this.timeName = setInterval(() => {
        this.timeSize = this.timeSize-1;
        let time1 = Math.floor(this.timeSize/60);
        let time2 = this.timeSize%60;
        this.time = `${time1}:${time2<10 ? '0'+time2 : time2}`;

        if(this.timeSize===0){
          clearInterval(this.timeName);
        }
      }, 1000);
    },

    copyText(){
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    copyTextError(){
      this.$message({
        message:'复制失败，请手动复制！',
        type:'error'
      })
    },
  }
}
</script>
<style lang="scss" scoped>
  .UserBindEmail{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: rgba($color: #000, $alpha: 0.4);
    &tipsState1{
      background: rgba($color: #000, $alpha: 0.2);
    }
    .tipsContent{
      left: 50%;
      top: 50%;
      box-sizing: border-box;
      width: 446px;
      box-shadow:0px 1px 3px 0px rgba(0,0,0,0.03);
      border-radius:4px;
      padding: 30px 32px 32px;
      transform: translate(-50%, -50%);
      .tipsTitle{
        line-height: 36px;
        .iconfont{
          font-size: 14px;
          padding: 0 5px;
        }
      }
      .tipsText{
        line-height: 28px;
      }

      .form{
        margin: 38px 0 48px;
        .formList{
          line-height: 14px;
          margin-bottom: 18px;
          .title{
            width: 66px;
          }
          .inputItem{
            height:40px;
            line-height: 38px;
            box-sizing: border-box;
            border-radius:29px;
            border:1px solid #ECECEC;
            .text{
              padding-left: 24px;
            }
            .time{
              opacity: .5;
              padding: 0 18px;
            }
            .upload{
              padding-right: 24px;
              .iconfont{
                font-size: 16px;
              }
            }
            .copyButton{
              width: 84px;
              height: 38px;
              background:rgba(65,131,255,0.07);
              &.disabled{
                background: #F9F9F9;
                color: #BCBCBC;
              }
            }
          }
        }
      }
      .submitButton{
        height:50px;
        line-height: 50px;
        border-radius:4px;
        &:hover{
          opacity: .9;
        }
        &.disabled{
          background: #F9F9F9;
          color: #BCBCBC;
        }
      }
      .errorTips{
        line-height: 16px;
        left: 0;
        right: 0;
        top: -26px;
        .iconfont{
          font-size: 16px;
        }
      }
    }
  }
  
</style>